import { render, staticRenderFns } from "./InquiryDetailModal.vue?vue&type=template&id=4c2be666&"
import script from "./InquiryDetailModal.vue?vue&type=script&lang=js&"
export * from "./InquiryDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports